'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flattenProp = require('recompose/flattenProp');

var _flattenProp2 = _interopRequireDefault(_flattenProp);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeHandlers = require('recompose-scope/exposeHandlers');

var _exposeHandlers2 = _interopRequireDefault(_exposeHandlers);

var _exposeNamespace = require('recompose-scope/exposeNamespace');

var _exposeNamespace2 = _interopRequireDefault(_exposeNamespace);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _mapValuesDeep = require('../../../utils/schema/mapValuesDeep');

var _mapValuesDeep2 = _interopRequireDefault(_mapValuesDeep);

var _queueHandlersAfter = require('coact-utils/queueHandlersAfter');

var _queueHandlersAfter2 = _interopRequireDefault(_queueHandlersAfter);

var _queueHandlersBefore = require('coact-utils/queueHandlersBefore');

var _queueHandlersBefore2 = _interopRequireDefault(_queueHandlersBefore);

var _isNil = require('coact-utils/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _isPlainObject = require('coact-utils/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isEmpty = require('coact-utils/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNotANumber = require('coact-utils/isNotANumber');

var _isNotANumber2 = _interopRequireDefault(_isNotANumber);

var _isArray = require('coact-utils/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function adaptReceivedData(value, _ref) {
  var type = _ref.type;

  if (type === 'Date') {
    return value && (0, _moment2.default)(value).toDate();
  }
  return value;
}
// receive: props => data => adapt(data)
var afterReceive = function afterReceive(_ref2) {
  var schema = _ref2.schema;
  return (0, _mapValuesDeep2.default)(schema)()(adaptReceivedData);
};
var afterQuery = function afterQuery(props) {
  return function (docs) {
    var adapter = afterReceive(props);
    return docs.map(adapter);
  };
};

function shouldSaveAsNull(value) {
  return (0, _isNil2.default)(value) || value === '' || (0, _isPlainObject2.default)(value) && (0, _isEmpty2.default)(value) || (0, _isArray2.default)(value) && (0, _isEmpty2.default)(value) || (0, _isNotANumber2.default)(value);
}
function adpatSendingData(value, _ref3) {
  var type = _ref3.type,
      autogeneratable = _ref3.autogeneratable;

  if (autogeneratable && value.startsWith('tmp_')) return undefined;
  if (shouldSaveAsNull(value)) return null;

  if (type === 'ObjectId') {
    return (0, _isPlainObject2.default)(value) ? value._id : value;
  }

  return value;
}
// send: props => data => adapt(data)
var beforeSend = function beforeSend(_ref4) {
  var schema = _ref4.schema;
  return (0, _mapValuesDeep2.default)(schema)()(adpatSendingData);
};

var shape = _propTypes2.default.shape,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object;

var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  db: shape({
    findDoc: func.isRequired,
    queryDocs: func.isRequired,
    insertDoc: func.isRequired,
    updateDoc: func.isRequired
  }),
  schema: object.isRequired
}), (0, _flattenProp2.default)('db'), (0, _exposeHandlers2.default)((0, _queueHandlersAfter2.default)({
  findDoc: afterReceive,
  queryDocs: afterQuery,
  insertDoc: afterReceive,
  updateDoc: afterReceive
})), (0, _exposeHandlers2.default)((0, _queueHandlersBefore2.default)({
  insertDoc: beforeSend,
  updateDoc: beforeSend
})), (0, _exposeNamespace2.default)('db'));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'adaptTransferringData');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/connectServer/adaptTransferringData.js
// module id = 1169
// module chunks = 0